import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { GlassBoxItem } from '../../../hooks/useGlassBoxEvents';

interface Props {
  item: GlassBoxItem;
}

export function ErrorEvent({ item }: Props) {
  const { data } = item;
  const message = typeof data.message === 'string' ? data.message : null;
  const code = typeof data.code === 'string' ? data.code : null;

  return (
    <div className="flex items-start gap-2 py-1.5 px-3 rounded bg-error-500/5 border-l-2 border-error-500/40 group">
      <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5 text-error-400" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-error-300">Error</span>
          {code && <span className="text-[10px] font-mono text-error-400">{code}</span>}
        </div>
        {message && (
          <p className="text-[10px] text-error-300/80 mt-0.5 break-words">{message}</p>
        )}
      </div>
      <div className="flex-shrink-0 text-[10px] text-text-muted opacity-0 group-hover:opacity-100 transition-opacity">
        {new Date(item.receivedAt).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </div>
    </div>
  );
}
